<template>
  <md-card>
    <div>
      <b-modal
        id="modal-kontragentset"
        title="Контрагент"
        hide-footer
        size="xl"
        @shown="Shovedform"
        @hidden="Hidecreate()"
      >
        <form>
          <div class="row">
            <div class="col-md-6">
              <span class="backblock">
                <div class="col-md-12 topheader">
                  <span>
                  <label>ФИО</label>
                  <input
                    ref="inputText1"
                    class="table-input"
                    @focus="show"
                    v-model="kontragent.name"
                    type="text"
                  />
                  </span>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("Манзил") }}</label>
                  <input
                  @focus="show"

                    class="table-input"
                    v-model="kontragent.address"
                    type="text"
                  />
                  </span>
                </div>
                <div style="display:flex">
                <div class="col-md-6 topheader">
                  <span>
                <label>Телефон</label>
                  <input
                  @focus="show"
                    class="table-input"
                    v-model="kontragent.phone_number"
                    type="text"
                  />
                  </span>
                </div>
                <div class="col-md-6 topheader">
                  <span>
                  <label>{{$t('Тўлов вақти')}}</label>
                  <input type="date"
                    class="table-input"
                    v-model="kontragent.payment_date"
                  ></textarea>
                  </span>
                </div>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("Склад") }}</label>
                  <v-select
                    :disabled="skladhave"
                    :clearable="false"
                    :options="skladlist"
                    v-model="kontragent.sklad_id"
                    :reduce="name => name.id"
                    label="name"
                  ></v-select>
                  </span>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("Тури") }}</label>
                  <v-select
                    :clearable="false"
                    :options="kontragent_type"
                    v-model="kontragent.type"
                    :reduce="name => name.id"
                    label="name"
                  ></v-select>
                  </span>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>Комментарий</label>
                  <input type="text" class="table-input"
                  @focus="show"
                    v-model="kontragent.comment"
                  >
                    </span>
                </div>
              </span>
            </div>
            <div class="col-md-6">
              <span class="backblock">
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("Папка") }}</label>
                  <input type="checkbox" v-model="kontragent.is_folder" />
                  </span>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("Гурух") }}</label>
                  <v-select
                    :clearable="true"
                    class="md-input"
                    :options="folder"
                    v-model="kontragent.parent_id"
                    :reduce="name => name.id"
                    label="name"
                  >
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em
                          ><b>{{ search }}</b></em
                        >
                        {{ $t("бўйича маьлумот йўқ") }}
                      </template>
                      <em style="opacity: 0.5;" v-else>{{
                        $t("Маьлумот йўқ")
                      }}</em>
                    </template>
                  </v-select>
                  </span>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("Фирма") }}</label>
                  <v-select
                    :clearable="false"
                    class="md-input"
                    :options="firmalist"
                    v-model="kontragent.firma_id"
                    :reduce="name => name.id"
                    label="name"
                  >
                    <template #search="{attributes, events}">
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                      <button
                        type="button"
                        class="modallist"
                        v-b-modal.modal-firmalist
                      >
                        <b-icon icon="three-dots"></b-icon>
                      </button>
                    </template>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em
                          ><b>{{ search }}</b></em
                        >
                        {{ $t("бўйича маьлумот йўқ") }}
                        <button
                          type="button"
                          @click="firma.name = search"
                          class="pluss"
                          v-b-modal.modal-firma
                        >
                          +
                        </button></template
                      >
                      <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                    </template>
                  </v-select>
                  </span>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("Хисоб рақам") }}</label>
                  <input
                  @focus="show"
                    class="table-input"
                    v-model="kontragent.account_number"
                    type="text"
                  />
                </span>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("ИНН") }}</label>
                  <input
                  @focus="show"
                    class="table-input"
                    v-model="kontragent.inn"
                    type="text"
                  />
                  </span>
                </div>
                <div style="display:flex">
                <div class="col-md-6 topheader">
                  <span>
                  <label>{{ $t("МФО") }}</label>
                  <input
                  @focus="show"
                    class="table-input"
                    v-model="kontragent.mfo_id"
                    type="text"
                  />
                  </span>
                </div>
                <div class="col-md-6 topheader">
                  <span>
                  <label>{{ $t("ОКОНХ") }}</label>
                  <input
                  @focus="show"
                    class="table-input"
                    v-model="kontragent.okonx"
                    type="text"
                  />
                  </span>
                </div>
                </div>
              </span>
            </div>
            <div class="col-md-12 modal-footer">
              <hr />
              <button
                type="button"
                class="btn btn-primary"
                @click="Updatekontragent()"
              >
                {{ $t("Сақлаш") }}
              </button>
            </div>
          </div>
          <div class="vozvrat" v-if="$route.path=='/chiqim/create'">
            <vue-touch-keyboard :options="options" :layout="layout1" :cancel="hide" :accept="accept" :input="input" />
            </div>
        </form>
      </b-modal>
      <b-modal
        id="modal-kontragent"
        title="Контрагент"
        hide-footer
        size="xl"
        @shown="Shovedform"
        @hidden="Hidecreate()"
      >
        <form>
          <div class="row">
            <div class="col-md-6">
              <span class="backblock">
                <div class="col-md-12 topheader">
                  <span>
                  <label>ФИО</label>
                  <input
                    ref="inputText1"
                    class="table-input"
                    @focus="show"
                    v-model="kontragentnew.name"
                    type="text"
                  />
                  </span>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("Манзил") }}</label>
                  <input
                  @focus="show"

                    class="table-input"
                    v-model="kontragentnew.address"
                    type="text"
                  />
                  </span>
                </div>
                <div style="display:flex">
                <div class="col-md-6 topheader">
                  <span>
                <label>Телефон</label>
                  <input
                  @focus="show"
                    class="table-input"
                    v-model="kontragentnew.phone_number"
                    type="text"
                  />
                  </span>
                </div>
                <div class="col-md-6 topheader">
                  <span>
                  <label>{{$t('Тўлов вақти')}}</label>
                  <input type="date"
                    class="table-input"
                    v-model="kontragentnew.payment_date"
                  ></textarea>
                  </span>
                </div>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("Склад") }}</label>
                  <v-select
                    :disabled="skladhave"
                    :clearable="false"
                    :options="skladlist"
                    v-model="kontragentnew.sklad_id"
                    :reduce="name => name.id"
                    label="name"
                  ></v-select>
                  </span>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("Тури") }}</label>
                  <v-select
                    :clearable="false"
                    :options="kontragent_type"
                    v-model="kontragentnew.type"
                    :reduce="name => name.id"
                    label="name"
                  ></v-select>
                  </span>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>Комментарий</label>
                  <input type="text" class="table-input"
                  @focus="show"
                    v-model="kontragentnew.comment"
                  >
                    </span>
                </div>
              </span>
            </div>
            <div class="col-md-6">
              <span class="backblock">
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("Папка") }}</label>
                  <input type="checkbox" v-model="kontragentnew.is_folder" />
                  </span>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("Гурух") }}</label>
                  <v-select
                    :clearable="true"
                    class="md-input"
                    :options="folder"
                    v-model="kontragentnew.parent_id"
                    :reduce="name => name.id"
                    label="name"
                  >
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em
                          ><b>{{ search }}</b></em
                        >
                        {{ $t("бўйича маьлумот йўқ") }}
                      </template>
                      <em style="opacity: 0.5;" v-else>{{
                        $t("Маьлумот йўқ")
                      }}</em>
                    </template>
                  </v-select>
                  </span>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("Фирма") }}</label>
                  <v-select
                    :clearable="false"
                    class="md-input"
                    :options="firmalist"
                    v-model="kontragentnew.firma_id"
                    :reduce="name => name.id"
                    label="name"
                  >
                    <template #search="{attributes, events}">
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                      <button
                        type="button"
                        class="modallist"
                        v-b-modal.modal-firmalist
                      >
                        <b-icon icon="three-dots"></b-icon>
                      </button>
                    </template>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em
                          ><b>{{ search }}</b></em
                        >
                        {{ $t("бўйича маьлумот йўқ") }}
                        <button
                          type="button"
                          @click="firma.name = search"
                          class="pluss"
                          v-b-modal.modal-firma
                        >
                          +
                        </button></template
                      >
                      <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                    </template>
                  </v-select>
                  </span>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("Хисоб рақам") }}</label>
                  <input
                  @focus="show"
                    class="table-input"
                    v-model="kontragentnew.account_number"
                    type="text"
                  />
                </span>
                </div>
                <div class="col-md-12 topheader">
                  <span>
                  <label>{{ $t("ИНН") }}</label>
                  <input
                  @focus="show"
                    class="table-input"
                    v-model="kontragentnew.inn"
                    type="text"
                  />
                  </span>
                </div>
                <div style="display:flex">
                <div class="col-md-6 topheader">
                  <span>
                  <label>{{ $t("МФО") }}</label>
                  <input
                  @focus="show"
                    class="table-input"
                    v-model="kontragentnew.mfo_id"
                    type="text"
                  />
                  </span>
                </div>
                <div class="col-md-6 topheader">
                  <span>
                  <label>{{ $t("ОКОНХ") }}</label>
                  <input
                  @focus="show"
                    class="table-input"
                    v-model="kontragentnew.okonx"
                    type="text"
                  />
                  </span>
                </div>
                </div>
              </span>
            </div>
            <div class="col-md-12 modal-footer">
              <hr />
              <button
                type="button"
                class="btn btn-primary"
                @click="Createkontragent()"
              >
                {{ $t("Сақлаш") }} <sup>ctrl+enter</sup>
              </button>
            </div>
          </div>
          <div class="vozvrat" v-if="$route.path=='/chiqim/create'">
          <vue-touch-keyboard :options="options" :layout="layout1" :cancel="hide" :accept="accept" :input="input" />
          </div>
        </form>
      </b-modal>
    </div>
    <div>
      <b-modal
        id="modal-kontragentlist"
        title="Контрагент"
        hide-footer
        size="xl"
        @shown="Shoved"
        @hidden="Hide()"
      >
        <div class="row">
          <div style="display:-webkit-inline-box">
            <button type="button" class="mybtn btn insert" v-b-modal.modal-kontragent>
              <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Қўшиш") }}<sup>ins</sup>
            </button>
            <input
              type="text"
              class="table-input searchtable"
              v-bind:placeholder="$t('Қидирув')"
              v-model="filter"
              ref="inputText1"
            />
          </div>
          <md-card>
            <md-card-content>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th></th>
                <!-- <th>№</th> -->
                <th>{{$t('Номи')}}</th>
                <th>Телефон</th>
                <th>{{$t('Манзил')}}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <span class="cursor" @click="Kontragentlistmodal(parent)">
                  <td>
                    <b-icon icon="arrow-left"></b-icon>
                  </td>
                  <!-- <td>{{ index + 1 }}</td> -->
                  <td colspan="3">
                    <button
                    type="button"
                    class="atable gohome"
                  >
                    ..
                    </button>
                  </td>
                </span>
                  <td>
                  </td>
              </tr>
              <span v-for="(item, index) in filteredRows"  class="cursor">
              <tr :class="item.is_folder == true ? 'folderyellow' : ''">
                <span class="cursor" @click="Selectkontragent(item)">
                <td >
                  <span v-if="item.is_folder==true">
                    <button type="button">
                      <b-icon icon="folder-fill"></b-icon>
                    </button>
                  </span>
                  <span v-else>
                    <!-- <b-icon icon="aspect-ratio"></b-icon> -->
                  </span>
                  <!-- <span class="end">{{item.id}}</span> -->
                </td>
                <!-- <td>{{ index + 1 }}</td> -->
                <td>
                  <button
                    type="button"
                    :class="item.is_folder == true ? 'atable folder' : 'atable'"
                  >
                    {{ item.name }}
                  </button>
                </td>
                <td>{{item.phone_number}}</td>
                <td>{{item.address}}</td>
              </span>
                <td>
                  <button
                    type="button"
                    class="mybtn btn"
                    @click="
                      kontragent = filteredRows[index];
                      sett = index;
                      kontragent.payment_date=new Date(kontragent.payment_date*1000).toISOString().slice(0, 10);

                    "
                    v-b-modal.modal-kontragentset
                  >
                    <b-icon icon="pencil"></b-icon><sup>(F2)</sup>
                  </button>
                  <button
                    type="button"
                    class="mybtn btn"
                    @click="Kontragenttrash(item.id,item.parent_id)"
                  >
                    <b-icon icon="trash"></b-icon><sup>(delete)</sup>
                  </button>
                </td>
              </tr>
              <!-- <b-collapse :id="'collapse-'+item.id">
                <tablechild :datas="datas" :indexed="1" :child="item.children" /> -->
              <!-- </b-collapse> -->
              </span>
            </tbody>
          </table>
          </md-card-content>
          </md-card>
        </div>
      </b-modal>
    </div>
  </md-card>
</template>
<script>
import $ from "jquery";
// import Tablechild from "./Kontragentchild.vue";
export default {
  name: "kontragent",
  data() {
    return {
      visible: false,
        input: null,
        options: {
          useKbEvents: false,
          preventClickEvent: false
        },
        layout1: {
          _meta: {
            "tab": { key: "\t", text: "Tab", width: 60, classes: "control" },
            "shiftl": { keySet: "shifted", text: "Shift", width: 100, classes: "control" },
            "shiftr": { keySet: "shifted", text: "Shift", width: 100, classes: "control" },
            "shiftlru": { keySet: "shifted_ru", text: "Shift", width: 100, classes: "control" },
            "shiftrru": { keySet: "shifted_ru", text: "Shift", width: 100, classes: "control" },
            "ru": { keySet: "default_ru", text: "ru", width: 40, classes: "control featured" },
            "eng": { keySet: "default", text: "eng", width: 40, classes: "control featured" },
            "caps": { keySet: "capsed", text: "Caps lock", width: 80, classes: "control" },
            "capsru": { keySet: "capsed_ru", text: "Caps lock", width: 80, classes: "control" },
            "space": { key: " ", text: "Space", width: 180 },
            "enter": { key: "\r\n", text: "Enter", width: 80, classes: "control" },
            "enter": { func: "enter", key: "\r\n", text: "Enter", width: 80, classes: "control" },
            "backspace": { func: "backspace", classes: "control backspace", width: 65 },
            "accept": { func: "accept", text: "Close", classes: "control" },
            "next": { func: "next", text: "Next", classes: "control featured" }
          },

          default: [
            "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
            "{tab} q w e r t y u i o p [ ] \\",
            "{caps} a s d f g h j k l ; ' {enter}",
            "{shiftl} z x c v b n m , . / {shiftr}",
            "{ru} {space} "
          ],
          shifted: [
            "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
            "{tab} Q W E R T Y U I O P { } |",
            "{caps} A S D F G H J K L : \" {enter}",
            "{shiftl} Z X C V B N M < > ? {shiftr}",
            "{ru} {space} "
          ],
          capsed: [
            "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
            "{tab} Q W E R T Y U I O P [ ] \\",
            "{caps} A S D F G H J K L ; ' {enter}",
            "{shiftl} Z X C V B N M , . / {shiftr}",
            "{ru} {space} "
          ],
          shifted_ru: [
            "Ё ! \" № ; % : ? * ( ) _ + {backspace}",
            "{tab} Й Ц У К Е Н Г Ш Щ З Х Ъ |",
            "{capsru} Ф Ы В А П Р О Л Д Ж Э {enter}",
            "{shiftlru} Я Ч С М И Т Ь Б Ю , {shiftrru}",
            "{eng} {space} "
          ],
          default_ru: [
            "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
            "{tab} й ц у к е н г ш щ з х ъ \\",
            "{capsru} ф ы в а п р о л д ж э {enter}",
            "{shiftlru} я ч с м и т ь б ю . {shiftrru}",
            "{eng} {space} "
          ],
          capsed_ru: [
            "Ё 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
            "{tab} Й Ц У К Е Н Г Ш Щ З Х Ъ \\",
            "{capsru} Ф Ы В А П Р О Л Д Ж Э {enter}",
            "{shiftlru} Я Ч С М И Т Ь Б Ю . {shiftrru}",
            "{eng} {space} "
          ]
        },
      parent:0,
      folderlist:[],
      list:[],
      focusset: "",
      folder:[],
      skladlist: [],
      kontragent: {
        payment_date:0,
        name: "",
        phone_number: "",
        account_number: "",
        inn: "",
        mfo_id: 0,
        okonx: "",
        parent_id:0,
        address: "",
        firma_id: 0,
        sklad_id: 0,
        is_folder: false,
        type: 2,
        comment: ""
      },
      firma: "",
      update_password:"",
      firmalist: [],
      kontragentnew: {
        payment_date:0,
        name: "",
        phone_number: "",
        account_number: "",
        inn: "",
        mfo_id: 0,
        okonx: "",
        address: "",
        parent_id:0,
        firma_id: 0,
        sklad_id: parseInt(localStorage.getItem('sklad_id')),
        is_folder: false,
        type: 2,
        comment: ""
      },
      kontragent_type: [
        { id: 1, name: "Клиент" },
        { id: 2, name: "Етказувчи" },
        { id: 3, name: "Клиент ва Етказувчи" }
      ],
      kontragentlist: [],
      filter: "",
      sett: null
    };
  },
  props: ["datas"],
  computed: {
    skladhave(){
      if(localStorage.getItem('sklad_id')>1){
        return true;
      }else{
        return false;
      }
    },
    filteredRows() {
      // Agar Kirim/Refundsuplier sahifasidan ochilgan bo'lsa — faqat ta'minotchilar (type=2)
      const rn = (this.$route && this.$route.name) || '';
      const onlySupplier = /Kirim|Кирим|Refundsuplier/i.test(rn);
      const byType = (arr) => onlySupplier ? arr.filter(r => Number(r.type) === 2 || r.is_folder) : arr;

      if(this.filter.length>1){
        const src = byType(this.kontragentlist);
        return src.filter(row => {
          const name = row.name.toString().toLowerCase();
          const searchTerm = this.filter.toLowerCase();
          return name.includes(searchTerm);
        });
      }else{
        return byType(this.folderlist);
      }
    }
  },
  methods: {
    accept(text) {
          alert("Input text: " + text);
          this.hide();
        },
 
        show(e) {
          this.input = e.target;
          this.layout = e.target.dataset.layout;
 
          if (!this.visible)
            this.visible = true
        },
 
        hide() {
          this.visible = false;
        },
    Selectkontragent(item){
      if(item.is_folder==false){
        let id=item.id;
      if(this.$route.name=='Kontragentinitial qoshish' || this.$route.name=='Kontragentinitial ўзгартириш'){
        this.datas.kontragent_initial_table[this.$store.state.select_kontragent].kontragent_id=id;
      } else {
        this.datas.kontragent_id=id
      }
        this.$bvModal.hide('modal-kontragentlist');
    }else{
      this.parent=item.parent_id;
      this.Kontragentlistmodal(item.id);
      setTimeout(() => {
        $('.atable:eq(0)').focus()
      }, 100);
    }
    },
    Folderlist(){
      let self = this;
        axios({
          method: "get",
          url: "api/v1/kontragent/folder-list"
        }).then(function(response) {
          self.folder=response.data;
        });
    },
    Kontragenttrash(id,parent) {
      let self=this;
      self.$bvModal.hide("modal-kontragentlist");
      self.$prompt(self.$t("Паролни киритинг")).then(text => {
          if (text == self.update_password) {
            axios({
          method: "delete",
          url: "api/v1/kontragent/id/" + id
        }).then(function(response) {
          self.Kontragentlist();
          self.Kontragentlistmodal(parent);
          self.$bvModal.show("modal-kontragentlist");
        });
          } else {
            self.$store.state.errors = self.$t("Парол хато");
          self.$bvModal.show("modal-kontragentlist");
          }
        })
        .catch(function() {});
    },
    Kontragentlist() {
      let self = this;
      axios.get("api/v1/kontragent").then(function(response) {
        self.kontragentlist = response.data;
        self.$root.$emit("kontragentall", response.data);
      });
    },
    Kontragentlistmodal(parent){
      let self=this;
      axios.get("api/v1/kontragent/all/"+parent).then(function(response) {
        if(response.data.length>0 && response.data[0].parent_id>0){
          axios
      .get("api/v1/kontragent/id/" + response.data[0].parent_id)
      .then(function(response) {
        self.parent = response.data.parent_id;
      });
        }
        self.folderlist = response.data;
      });
    },
    Updatekontragent() {
      let self = this;
      self.kontragent.payment_date=new Date(self.kontragent.payment_date).valueOf().toString().slice(0, 10);
      axios({
        method: "patch",
        url: "api/v1/kontragent/id/" + self.kontragent.id,
        data: self.kontragent
      }).then(function(response) {
        self.Kontragentlist();
        self.Kontragentlistmodal(self.kontragent.parent_id);
        self.$store.state.saved_modal = "updated";
        self.$bvModal.hide("modal-kontragentset");
        self.kontragent = {
          name: "",
          phone_number: "",
          account_number: "",
          inn: "",
          mfo_id: 0,
          okonx: "",
          address: "",
          firma_id: 0,
          sklad_id: 0,
          is_folder: false,
          type: 2,
          comment: ""
        };
      });
    },
    Sklad() {
      let self = this;
      axios
        .get("api/v1/sklads/id/" + localStorage.getItem("sklad_id"))
        .then(function(response) {
          self.update_password = response.data.update_password;
      });
    },
    Shovedform() {
      this.$bvModal.hide("modal-kontragentlist");
      if (this.$store.state.saved_modal == "update") {
        this.$store.state.saved_modal = null;
      }
      let self = this;
      $(document).on("focusout", function(e) {
        if ($(e.target).parents('.modal-body').attr('class')==undefined && $(e.target).attr("class") == "vs__search") {
          // if (self.focusset == "") {
            self.focusset = e.target;
           // }
        }
      });
      self.$refs.inputText1.focus();
    },
    Shoved() {
      let self = this;
      $(document).on("focusout", function(e) {
        if ($(e.target).attr("class") == "vs__search") {
          if (self.focusset == "") {
            self.focusset = e.target;
          }
        }
      });
      if (self.sett == "create") {
        var set =$('#modal-kontragentlist___BV_modal_content_').find(".atable").not('.folder');
        set[1].focus();
      } else if (self.sett == null) {
        self.$refs.inputText1.focus();
      } else if (self.sett >= 0) {
        var set = $('#modal-kontragentlist___BV_modal_content_').find(".atable").not('.folder');
        set[self.sett].focus();
      }
    },
    Hide() {
      let self = this;
      setTimeout(function(e) {
        var classs = $(":focus");
        var rrr = $("body").find("input,select,textarea,button").filter(":visible");
        if (classs.attr("class") == "modallist") {
          if ($(self.focusset).siblings(".vs__selected").attr("class") != undefined) {
            var focused = rrr.eq(rrr.index(classs) + 1);
            focused.focus();
          } else {
            $(self.focusset).focus();
          }
        } else if (classs.attr("class") == undefined) {
          if ($(self.focusset).siblings(".vs__selected").attr("class") != undefined) {
            focused = rrr.eq(rrr.index($(self.focusset)) + 2);
            focused.focus();
            self.focusset='';
          } else {
            $(self.focusset).focus();
            self.focusset='';
          }
        } else if (classs.attr("class") == "modal-content") {
          self.$refs.inputText1.focus();
        }
      }, 100);
    },
    Hidecreate() {
      if (this.$store.state.saved_modal == "create") {
        const answer = window.confirm(
          this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
        );
        if (answer) {
          this.Createkontragent();
        } else {
          this.New();
          this.$store.state.saved_modal = null;
        }
      } else if (this.$store.state.saved_modal == "update") {
        const answer = window.confirm(
          this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
        );
        if (answer) {
          this.Updatekontragent();
        }
      }
      this.$store.state.saved_modal = null;
      this.$bvModal.show("modal-kontragentlist");
    },
    New() {
      this.kontragentnew = {
        payment_date:0,
        name: "",
        phone_number: "",
        account_number: "",
        inn: "",
        mfo_id: 0,
        okonx: "",
        address: "",
        firma_id: 0,
        sklad_id: parseInt(localStorage.getItem('sklad_id')),
        is_folder: false,
        type: 2,
        comment: ""
      };
      this.$root.$emit("kontragentone", this.kontragentnew);
    },
    Createkontragent() {
      let self = this;
      self.kontragentnew.payment_date=new Date(self.kontragentnew.payment_date).valueOf().toString().slice(0, 10);
      axios({
        method: "post",
        url: "api/v1/kontragent",
        data: self.kontragentnew
      }).then(function(response) {
        if(self.kontragentnew.is_folder==false){
          self.kontragentlist.push(response.data);
        }
        self.Kontragentlistmodal(self.kontragentnew.parent_id);
        self.$store.state.saved_modal = "created";
        self.New();
        self.$bvModal.hide("modal-kontragent");
        self.sett = "create";
      });
    }
  },
  watch: {
    kontragent: {
      deep: true,
      handler(val, oldVal) {
        if (this.$store.state.saved_modal == null) {
          this.$store.state.saved_modal = "update";
        }
      }
    },
    kontragentnew: {
      deep: true,
      handler(val, oldVal) {
        if (val.name != "") {
          this.$store.state.saved_modal = "create";
        } else {
          this.$store.state.saved_modal = null;
        }
      }
    }
  },
  created() {
    this.$root.$emit("kontragentone", this.kontragentnew);
    this.Kontragentlist();
    this.Kontragentlistmodal(0);
    this.Folderlist();
    this.Sklad();
    let self = this;
    self.$root.$on("skladall", function(getdata) {
      self.skladlist = getdata;
    });
    self.$root.$on("firmaone", function(getdata) {
      self.firma = getdata;
    });
    self.$root.$on("firmaall", function(getdata) {
      self.firmalist = getdata;
    });
    self.$root.$on("firmaselected", function(getdata) {
      self.kontragent.firma_id = getdata;
      self.kontragentnew.firma_id = getdata;
    });
  }
};
</script>
<style lang="scss" scoped>
.md-dialog .md-dialog-container {
  max-width: 768px;
}
</style>
